import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { ButtonGroup } from 'stories/components'

import { type DocumentConfig, documentTabs } from './constants'
import { GeneratedSignedPdf } from './GeneratedSignedPdf'

export const Documents = () => {
  const [tab, setTab] = useState('generatedSignedPdf')
  const [isLoading, setIsLoading] = useState(false)
  const [staticValues, setStaticValues] = useState<Record<string, any>>({})
  const [config, setConfig] = useState<DocumentConfig>({})
  const [changed, setChanged] = useState(false)

  useEffect(() => {
    fetchConfig()
  }, [])

  const fetchConfig = async () => {
    setIsLoading(true)
    const { static: staticValues, data } = await getAdminConfig('documents')
    setConfig(data || {})
    setStaticValues(staticValues || {})
    setChanged(false)
    setIsLoading(false)
  }

  const onConfigChange = (section: keyof DocumentConfig, key: string, data: Record<string, any>) => {
    const updated = cloneDeep(config)
    if (!updated[section]) updated[section] = {}
    updated[section]![key] = { ...updated[section]![key], ...data }
    setConfig(updated)
    setChanged(true)
  }

  const onSave = async () => {
    setIsLoading(true)
    await setAdminConfig('documents', config)
    toast('Configuration saved successfully', { type: 'success' })
    setChanged(false)
    setIsLoading(false)
  }

  const renderContent = () => {
    switch (tab) {
      case 'generatedSignedPdf':
        return (
          <GeneratedSignedPdf
            staticValues={staticValues.generatedSignedPdf || {}}
            config={config.generatedSignedPdf || {}}
            isLoading={isLoading}
            onChange={(key, data) => onConfigChange('generatedSignedPdf', key, data)}
          />
        )
      default:
        return null
    }
  }

  return (
    <div>
      <ButtonGroup title={documentTabs} value={tab} onChange={setTab} />

      <div className="relative">
        <LayoutLoading show={isLoading} />
        {renderContent()}
      </div>

      <SaveChanges show={changed} onSave={onSave} />
    </div>
  )
}
